
import { useCallback, useEffect, useState } from "react";
import {
    ProductAddToCart,
    ProductCountAction,
} from "../styles/product";
import { RemoveProductFromCart, GetProductsInCartByUserId, AddProductToCart, UpdateProduct } from "../utils/productInCart";
import Swal from 'sweetalert2';
import { ADD_ITEM } from "../features/productInCartSlice";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import { CounterWrapper, CounterArrow, CounterValue } from "../styles/product"; // לפי הנתיב שלך
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import QuantityCounter from "./QuantityCounter"; // לפי הנתיב הנכון
import { Box } from "@mui/material";

const ProductButtons = ({ product, selectedVariations }) => {
    const selectedOptionId =
        selectedVariations?.Color?.id ?? selectedVariations?.Color?.Id ??
        selectedVariations?.Size?.id ?? selectedVariations?.Size?.Id ??
        null;
    const selectedOption =
        selectedVariations?.Color ?? selectedVariations?.Size ?? null;

    const productOption = selectedOption
        ? {
            id: selectedOption.id ?? selectedOption.Id,
            optionType: selectedOption.optionType ?? selectedOption.OptionType,
            value: selectedOption.value ?? selectedOption.Value,
            extraPrice: selectedOption.extraPrice ?? selectedOption.ExtraPrice ?? null,
            quantity: selectedOption.quantity ?? selectedOption.Quantity ?? null,
        }
        : null;



    const dispatch = useDispatch();

    const loggedUser = useSelector(state => state.user.logedUser);//בשביל שימוש מהסלייס - לזהות את המשתמש ונלקח מסלייס
    const navigate = useNavigate()
    const cart = useSelector(state => state.cart.items)    //בשביל לזהות אם המוצר קיים כבר בעגלה
    const existProduct = cart?.find(
        (item) =>
            item.productId === product?.id &&
            (item.productOptionId ?? null) === (selectedOptionId ?? null)
    );

    const addToCartText = existProduct ? "עדכן כמות" : "הוסף לסל ";
    const productAmount = existProduct?.amount ?? 1

    const [count, setCount] = useState(productAmount);

    useEffect(() => {
        setCount(productAmount);
    }, [productAmount, product?.id]);

    // useEffect(()=>{

    // }, [])

    const addToCart = async () => {



        // RemoveProductFromCart(productInCart).then(() => {
        //   dispatch((prevCart) => {
        //     return prevCart.filter((item) => item.id !== product.id);
        //   });
        // })

    };



    const checkLoginUser = () => {
        if (!loggedUser) {
            Swal.fire({
                title: "",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: "התחבר עכשיו",
                cancelButtonText: 'המשך לא מחובר',
                customClass: {
                    popup: 'custom-swal'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/signIn')
                }
            });
            return false
        }
        return true
    }

    const handleIncrease = () => {
        setCount(count + 1)
    };

    const handleDecrease = () => {
        setCount(count - 1);
    };

    const handleCountChange = (event) => {
        const raw = event.target.value;

        // אם ריק – נשאיר 0 (או 1, אם את מעדיפה)
        if (raw === "") {
            setCount(0);
            return;
        }

        let value = Number(raw);
        if (Number.isNaN(value)) return;

        // לא פחות מ-0
        if (value < 0) value = 0;

        // לא יותר מהמלאי
        if (value > product.quantity) value = product.quantity;

        setCount(value);
    };

    //פונקציה להודעה: הוסף מוצר בהצלחה
    const addToCartWithNotification = () => {

        if (existProduct) {
            navigate("/cart");
            return;
        }

        if (!checkLoginUser() || count === 0)
            return

        const isProductInCart = cart.find(
            (item) =>
                item.productId === product.id &&
                (item.productOptionId ?? null) === (selectedOptionId ?? null)
        );


        //יצירת אוביקט בשביל לשלוח לדטה בייס
        const productInCart = {
            amount: count,
            customerId: loggedUser ? loggedUser.id : null,// בדיקת תנאי לפני הגישה למשתנה
            productId: product ? product.id : null,
            productOptionId: selectedOptionId ?? null,
            productOption, 
            product: product
        }
        const dtoToServer = {
            amount: count,
            customerId: loggedUser?.id ?? null,
            productId: product?.id ?? null,
            productOptionId: selectedOptionId ?? null,
        };
        // const updatedProduct = {...product, amount: count}
        // const newProduct = { ...product, productInCarts: [productInCart] }

        if (!isProductInCart) {
            AddProductToCart({ ...dtoToServer, product: null }).then((res) => {
                if (res.status === 200)
                    dispatch(ADD_ITEM({ ...productInCart, id: res.data.id }));
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "המוצר נוסף בהצלחה לסל",
                    showConfirmButton: false,
                    customClass: {
                        popup: 'custom-swal'
                    },
                    timer: 1000
                });
            })
        }
        else {
            UpdateProduct(isProductInCart.id, productInCart).then((res) => {
                if (res.status === 200) {
                    dispatch(ADD_ITEM({ ...productInCart, id: isProductInCart.id }));
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "המוצר התעדכן בהצלחה",
                        showConfirmButton: false,
                        customClass: {
                            popup: 'custom-swal'
                        },
                        timer: 1000
                    });
                }
            })
        };

    };


    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 2, mt: 1 }}>
            {/* <div style={{ display: 'flex', flexDirection: 'row', width: '200px', justifyContent: 'space-between', marginTop: '10px' }}>
            <ProductCountAction onClick={handleIncrease} disabled={product.quantity < count}>
                +
            </ProductCountAction>
            <span className="counter" >{count}</span>
            <ProductCountAction onClick={handleDecrease} disabled={count === 0}>
                -
            </ProductCountAction>
        </div> */}
            {/* <CounterWrapper sx={{}}> */}
            {/* חץ למעלה = פלוס */}
            {/* <CounterArrow
                    type="button"
                    onClick={handleIncrease}
                    disabled={product.quantity <= count}
                >
                    <KeyboardArrowUpIcon fontSize="small" color="#58A76B" />
                </CounterArrow> */}

            {/* המספר באמצע */}
            {/* <CounterValue
                    type="number"
                    value={count}
                    onChange={handleCountChange}
                    min={0}
                    max={product.quantity}
                ></CounterValue> */}

            {/* חץ למטה = מינוס */}
            {/* <CounterArrow
                    type="button"
                    onClick={handleDecrease}
                    disabled={count === 0}
                >
                    <KeyboardArrowDownIcon fontSize="small" />
                </CounterArrow>
            </CounterWrapper> */}
            {!existProduct && (
                <QuantityCounter
                    value={count}
                    max={product.quantity}
                    onChange={setCount}
                />
            )}

            <ProductAddToCart onClick={addToCartWithNotification} variant="contained">
                {/* // show={showOptions}  */}
                {addToCartText}
            </ProductAddToCart>
        </Box>
    );
}
export default ProductButtons